import { Capacitor, registerPlugin } from '@capacitor/core';

const FacebookEvents = Capacitor.isNativePlatform()
  ? registerPlugin('FacebookEvents')
  : null;

/**
 * Log signup/registration event to Meta
 * @param {string} method - Registration method (e.g., 'email', 'google')
 */
export const logSignup = async (method = 'email') => {
  if (!FacebookEvents) return;
  try {
    await FacebookEvents.logSignup({ method });
  } catch {
    // Silent fail - analytics should never break the app
  }
};

/**
 * Log add transaction event to Meta
 * @param {string} type - Transaction type ('expense', 'income', 'transfer')
 * @param {number} amount - Transaction amount
 * @param {string} category - Transaction category
 */
export const logTransaction = async (type = 'expense', amount = 0, category = '') => {
  if (!FacebookEvents) return;
  try {
    await FacebookEvents.logTransaction({ type, amount, category });
  } catch {
    // Silent fail
  }
};

/**
 * Log a generic custom event to Meta
 * @param {string} name - Event name
 */
export const logCustomEvent = async (name) => {
  if (!FacebookEvents) return;
  try {
    await FacebookEvents.logEvent({ name });
  } catch {
    // Silent fail
  }
};
